import { Reducer } from "redux";
import { IJobsFeedState, JobsFeedActionsTypes } from "./jobsFeed.types";
import { ActionType } from "store/types";

export const initialState: IJobsFeedState = {
  pathname: "",
  pageNumber: "",
  breakdownId: "",
  isBackToJobsFeed: false,
};

const reducer: Reducer<IJobsFeedState, any> = (
  state: IJobsFeedState = initialState,
  action: JobsFeedActionsTypes
) => {
  switch (action.type) {
    case ActionType.SetJobsFeedData:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
